import { render, staticRenderFns } from "./AppealUser.vue?vue&type=template&id=02d2bf60&scoped=true"
import script from "./AppealUser.vue?vue&type=script&lang=js"
export * from "./AppealUser.vue?vue&type=script&lang=js"
import style0 from "./AppealUser.vue?vue&type=style&index=0&id=02d2bf60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d2bf60",
  null
  
)

export default component.exports